"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _connectionInteractions = _interopRequireDefault(require("./connectionInteractions"));

var _getStartedCardInteractions = _interopRequireDefault(require("./getStartedCardInteractions"));

var _reducer = _interopRequireDefault(require("settings-ui-sdk/Ecommerce/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/EcommerceImport/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/EcommerceWorkflows/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-ui-sdk/ShopifyConnection/reducer"));

var _reducer5 = _interopRequireDefault(require("settings-ui-sdk/Integrations/reducer"));

var _reducer6 = _interopRequireDefault(require("settings-ui-sdk/EcommerceV2/reducer"));

var _settingsInteractions = _interopRequireDefault(require("../multistore/reducers/settingsInteractions"));

var _reducer7 = _interopRequireDefault(require("settings-ui-sdk/EcommerceV2/Shopify/reducer"));

var _default = (0, _redux.combineReducers)({
  connectionInteractions: _connectionInteractions.default,
  getStartedCardInteractions: _getStartedCardInteractions.default,
  settingsInteractions: _settingsInteractions.default,
  ecommerce: _reducer.default,
  ecommerceV2: _reducer6.default,
  shopify: _reducer7.default,
  ecommerceImport: _reducer2.default,
  ecommerceWorkflows: _reducer3.default,
  shopifyConnection: _reducer4.default,
  integrations: _reducer5.default
});

exports.default = _default;
module.exports = exports.default;